export default "__VITE_ASSET__DZEA7Xtp__"